<template>
    <div class="user">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2">
                    <nacUser></nacUser>
                </b-col>

                <b-col cols="12" md="10">
                <b-row>
                <b-col cols="12">
                    <b-card class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">基本資料</span>
                        </template>
                        <b-form>
                            <b-row>
                                <b-col cols="12" md="6">
                                    <b-form-group label-for="profile-first-name">
                                        <template #label><b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>姓氏</template>
                                        <b-form-input
                                            id="profile-first-name"
                                            v-model="Member.User.FirstName"
                                            type="text"
                                            placeholder="姓氏"
                                            required
                                            :state="getFieldState('FirstName')"
                                            @input="onFieldInput('FirstName')"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.FirstName">
                                            {{ formErrors.FirstName }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" md="6">
                                    <b-form-group label-for="profile-last-name">
                                        <template #label><b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>名字</template>
                                        <b-form-input
                                            id="profile-last-name"
                                            v-model="Member.User.LastName"
                                            type="text"
                                            placeholder="名字"
                                            required
                                            :state="getFieldState('LastName')"
                                            @input="onFieldInput('LastName')"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.LastName">
                                            {{ formErrors.LastName }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" md="6">
                                    <b-form-group label-for="profile-gender" :state="getFieldState('Gender')">
                                        <template #label><b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>性別</template>
                                        <b-form-radio-group
                                            id="profile-gender"
                                            v-model="Member.Gender"
                                            :options="options"
                                            name="profile-gender-options"
                                            :state="getFieldState('Gender')"
                                            @change="onFieldInput('Gender')"
                                        ></b-form-radio-group>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Gender">
                                            {{ formErrors.Gender }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" md="6">
                                    <b-form-group label-for="profile-birthday">
                                        <template #label>
                                            <b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>出生日期（範例：1990-12-14）
                                        </template>
                                        <b-form-input
                                            id="profile-birthday"
                                            v-model="Member.Birthday"
                                            type="text"
                                            placeholder="出生日期"
                                            required
                                            :state="getFieldState('Birthday')"
                                            @input="onFieldInput('Birthday')"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Birthday">
                                            {{ formErrors.Birthday }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" md="6">
                                    <b-form-group label-for="profile-phone">
                                        <template #label><b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>行動電話</template>
                                        <b-form-input
                                            id="profile-phone"
                                            v-model="Member.Phone"
                                            type="text"
                                            placeholder="行動電話"
                                            required
                                            :state="getFieldState('Phone')"
                                            @input="onFieldInput('Phone')"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Phone">
                                            {{ formErrors.Phone }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" md="6">
                                    <b-form-group label-for="profile-email">
                                        <template #label><b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>電子信箱</template>
                                        <b-form-input
                                            id="profile-email"
                                            v-model="Member.User.Mail"
                                            type="text"
                                            placeholder="電子信箱"
                                            required
                                            :state="getFieldState('Email')"
                                            @input="onFieldInput('Email')"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Email">
                                            {{ formErrors.Email }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-form-group label-for="profile-address">
                                <template #label><b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>通訊地址</template>
                                <b-row>
                                    <b-col cols="12" md="3">
                                        <b-form-select
                                            v-model="Member.CityId"
                                            class="mb-3"
                                            :state="getFieldState('CityId')"
                                            @change="onCityChange(); onFieldInput('CityId')"
                                        >
                                            <b-form-select-option :value="null" disabled>請選擇縣市</b-form-select-option>
                                            <b-form-select-option v-for="c in City" :key="c.Id" :value="c.Id">
                                                {{ c.Name }}
                                            </b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="3">
                                        <b-form-select
                                            v-model="Member.TownId"
                                            class="mb-3"
                                            :disabled="!Member.CityId"
                                            :state="getFieldState('TownId')"
                                            @change="onFieldInput('TownId')"
                                        >
                                            <b-form-select-option :value="null">請選擇鄉鎮市區</b-form-select-option>
                                            <b-form-select-option v-for="t in filteredTowns" :key="t.Id" :value="t.Id">
                                                {{ t.Name }}
                                            </b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <b-form-input
                                            id="profile-address"
                                            v-model="Member.Address"
                                            type="text"
                                            placeholder="請輸入通訊地址"
                                            required
                                            :state="getFieldState('Address')"
                                            @input="onFieldInput('Address')"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Address">
                                            {{ formErrors.Address }}
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                                <b-form-invalid-feedback v-if="submitAttempted && formErrors.CityId">
                                    {{ formErrors.CityId }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-if="submitAttempted && formErrors.TownId">
                                    {{ formErrors.TownId }}
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-button variant="primary" @click.prevent="form1Save()">儲存</b-button>
                        </b-form>
                    </b-card>
                </b-col>
                </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import moment from 'moment';
import nacUser from '@/components/nacUser.vue';
import {
    apiGetCityTown,
    apiGetMember,
    apiPutMember,
} from '@/api/API.js';

const createDefaultMember = () => ({
    User: {
        FirstName: '',
        LastName: '',
        Mail: '',
        Id: '',
    },
    Gender: null,
    Birthday: '',
    Phone: '',
    Address: '',
    City: '',
    Town: '',
    CityId: null,
    TownId: null,
});

export default {
    name: 'user-profile',
    components: {
        nacUser,
    },
    data() {
        return {
            title: '基本資料',
            options: [
                { text: '女', value: 0 },
                { text: '男', value: 1 },
            ],
            City: [],
            Town: [],
            Member: createDefaultMember(),
            filteredTowns: [],
            submitAttempted: false,
            formErrors: {},
        };
    },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) == '') {
            alert('請先登入會員');
            this._go('/');
            return;
        }
        this.Init();
    },
    methods: {
        logout() {
            const data1 = this._storeData('Header_form1');
            if (this.IsNull(data1) !== '') {
                data1.text = '學員登入';
            }
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
        onCityChange() {
            this.filteredTowns = this.Town.filter((item) => item.Fk == this.Member.CityId);
            if (!this.filteredTowns.some((town) => town.Id === this.Member.TownId)) {
                this.Member.TownId = null;
            }
        },
        validateProfile() {
            const member = this.Member || {};
            const user = member.User || {};
            const errors = {};
            const firstName = (user.FirstName || '').trim();
            const lastName = (user.LastName || '').trim();
            const birthday = (member.Birthday || '').trim();
            const phone = (member.Phone || '').trim();
            const email = (user.Mail || '').trim();
            const address = (member.Address || '').trim();
            const gender = member.Gender;

            if (!firstName) errors.FirstName = '請輸入姓氏';
            if (!lastName) errors.LastName = '請輸入名字';
            if (gender === '' || gender === null || typeof gender === 'undefined') {
                errors.Gender = '請選擇性別';
            }
            if (!birthday) {
                errors.Birthday = '請輸入出生日期';
            } else if (!moment(birthday, 'YYYY-MM-DD', true).isValid()) {
                errors.Birthday = '出生日期格式需為 YYYY-MM-DD';
            }
            if (!phone) errors.Phone = '請輸入行動電話';
            if (!email) {
                errors.Email = '請輸入電子信箱';
            } else if (!/^\S+@\S+\.\S+$/.test(email)) {
                errors.Email = '電子信箱格式不正確';
            }
            if (!member.CityId) errors.CityId = '請選擇縣市';
            if (member.CityId && !member.TownId) errors.TownId = '請選擇鄉鎮市區';
            if (!address) errors.Address = '請輸入通訊地址';

            return errors;
        },
        getFieldState(field) {
            if (!this.submitAttempted) return null;
            return this.formErrors[field] ? false : true;
        },
        onFieldInput() {
            if (!this.submitAttempted) return;
            this.formErrors = this.validateProfile();
        },
        Init() {
            this.GetMember();
        },
        async GetList() {
            try {
                const paging = {
                    pageSize: 9999,
                    pageNumber: 1,
                    totalCount: 0,
                    totalPages: 0,
                    previousPage: true,
                    nextPage: true,
                };

                const [cityRes, townRes] = await Promise.all([
                    apiGetCityTown({ Paging: paging, Search: { keywords: 'city' } }),
                    apiGetCityTown({ Paging: paging, Search: { keywords: 'town' } }),
                ]);

                this.City = cityRes.data;
                this.Town = townRes.data;

                if (!this.Member.CityId && this.Member.City) {
                    const city = this.City.find((item) => item.Name === this.Member.City);
                    this.Member.CityId = city?.Id ?? null;
                }

                this.filteredTowns = this.Town.filter((item) => item.Fk == this.Member.CityId);

                if (!this.Member.TownId && this.Member.Town) {
                    const town = this.filteredTowns.find((item) => item.Name === this.Member.Town);
                    this.Member.TownId = town?.Id ?? null;
                }
            } catch (err) {
                void err;
            }
        },
        GetMember() {
            apiGetMember()
                .then((res) => {
                    this.Member = {
                        ...createDefaultMember(),
                        ...res.data,
                        User: {
                            ...createDefaultMember().User,
                            ...(res.data?.User || {}),
                        },
                    };
                    this.Member.Birthday = this.Member.Birthday
                        ? moment(this.Member.Birthday).format('YYYY-MM-DD')
                        : '';
                    this.submitAttempted = false;
                    this.formErrors = {};
                    this.GetList();
                })
                .catch((err) => {
                    alert('請先登入會員');
                    void err;
                    this._go('/');
                });
        },
        form1Save() {
            this.submitAttempted = true;
            this.formErrors = this.validateProfile();
            if (Object.keys(this.formErrors).length) {
                return;
            }

            const city = this.City.find((item) => item.Id === this.Member.CityId);
            const town = this.Town.find((item) => item.Id === this.Member.TownId);

            const payload = {
                ...this.Member,
                City: city?.Name || '',
                Town: town?.Name || '',
            };

            apiPutMember(payload)
                .then(() => {
                    alert('基本資料已更新');
                    location.reload();
                })
                .catch((err) => {
                    void err;
                });
        },
    },
};
</script>

<style scoped>
</style>
